import { VEHICLE_TYPE as VEHICLE_TYPE_FIELD } from "./";
import { ALL } from "../strings";

const OPTIONS = {
  0: { label: ALL },
  1: {
    label: "3.5t",
    functionParameters: {
      field: "code",
      value: "SPR",
    },
  },
  2: {
    label: "Lites",
    functionParameters: {
      field: "code",
      value: "LTE",
    },
  },
  3: {
    label: "Green",
    functionParameters: {
      field: "electricVehicle",
      value: true,
    },
  },
  4: {
    label: "Artic",
    functionParameters: {
      field: "code",
      value: "CL1",
    },
  },
  5: {
    label: "7.5t",
    functionParameters: {
      field: "code",
      value: "7T5",
    },
  },
  6: {
    label: "17/18t",
    functionParameters: {
      field: "code",
      value: "TON",
    },
  },
};

export const VEHICLE_TYPE = {
  title: "Vehicle Type",
  field: VEHICLE_TYPE_FIELD,
  values: Object.keys(OPTIONS).map((option) => ({
    value: option,
    ...OPTIONS[option],
  })),
  filterCallback: ({ vehicle, field, value }) => vehicle?.[field] === value,
  volumeOverlayRequired: false,
};
